'use strict';

var Backbone = require('backbone');
var _ = require('lodash');


var Router = Backbone.Router.extend({

    /**
     * Removes dependencies on Backbone.History
     * @param route
     * @param name
     * @param callback
     * @returns {exports}
     */
    route: function (route, name, callback) {
        if (!_.isRegExp(route)) route = this._routeToRegExp(route);
        if (_.isFunction(name)) {
            callback = name;
            name = '';
        }
        if (!callback) callback = this[name];
        var router = this,
            cb = function (fragment) {
                var args = router._extractParameters(route, fragment);
                router.execute(callback, args);
                router.trigger.apply(router, ['route:' + name].concat(args));
                router.trigger('route', name, args);
            };
        if(_.isUndefined(this.handlers)) this.handlers = [];
        this.handlers.unshift({route: route, callback: cb});

        return this;
    },

    /**
     * Instead of proxy to Backbone.History - tell the router to execute the callback
     * @param fragment
     * @param options
     * @returns {*}
     */
    navigate: function (fragment, options) {
        if (!options || options === true) options = {trigger: !!options};
        if (options.trigger) return this.loadFrag(fragment);

        return this;
    },

    /**
     * @param fragment
     * @returns {*}
     */
    loadFrag: function (fragment) {

        fragment = fragment.replace(/^[#\/]|\s+$/g, '');
        return _.any(this.handlers, function (handler) {
            if (handler.route.test(fragment)) {
                handler.callback(fragment);
                return true;
            }
        });
    }
});

module.exports = Router;


//////////////////
// WEBPACK FOOTER
// ./node_modules/tscom-util/src/windowlessrouter.js
// module id = 236
// module chunks = 0